"use client"

import { useCallback } from "react"
import { useRouter, useSearchParams } from "next/navigation"
import { useCatalogTransition } from "@/components/public/CatalogTransitionContext"
import { useTranslations } from "@/lib/i18n/client"
import { cn, FILTER_PENDING_CLASSES } from "@/lib/utils"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { CatalogViewToggle } from "@/components/public/CatalogViewToggle"

export function CatalogToolbar() {
  const { t } = useTranslations()
  const router = useRouter()
  const searchParams = useSearchParams()
  const { isPending, startTransition } = useCatalogTransition()

  const currentOrdem = searchParams.get("ordem") ?? "destaque"

  const setOrdem = useCallback(
    (value: string) => {
      const params = new URLSearchParams(searchParams.toString())
      if (value === "destaque") params.delete("ordem")
      else params.set("ordem", value)
      params.delete("pagina")
      const qs = params.toString()
      startTransition(() => {
        router.push(qs ? `/aeronaves?${qs}` : "/aeronaves")
      })
    },
    [router, searchParams, startTransition],
  )

  const ordemOptions = [
    { value: "destaque", label: t.catalog.relevance },
    { value: "preco_asc", label: t.catalog.lowestPrice },
    { value: "preco_desc", label: t.catalog.highestPrice },
    { value: "ano_desc", label: t.catalog.newestYear },
    { value: "ano_asc", label: t.catalog.oldestYear },
    { value: "horas_asc", label: t.catalog.hoursAsc },
    { value: "horas_desc", label: t.catalog.hoursDesc },
  ]

  return (
    <div
      aria-busy={isPending}
      className={cn(
        "mb-4 flex flex-wrap items-center justify-end gap-3",
        isPending && FILTER_PENDING_CLASSES,
      )}
    >
      <div className="flex w-full items-center gap-2.5 sm:w-auto">
        <Select value={currentOrdem} onValueChange={setOrdem}>
          <SelectTrigger className="h-9 flex-1 text-[13px] sm:flex-initial sm:min-w-[180px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {ordemOptions.map((opt) => (
              <SelectItem key={opt.value} value={opt.value}>
                {opt.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <CatalogViewToggle />
      </div>
    </div>
  )
}
